// extracted by mini-css-extract-plugin
export var fadeIn = "_24-0";